import { newAPI } from "../newAxios";

// Fetch all user roles
export const fetchUserRolesAPI = async (data) => {
    const { payload } = data.data;
    try {
        const response = await newAPI.post('/user/all', payload);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// Fetch all users with pagination and filters
export const fetchUsersAPI = async (payload) => {
    try {
        const { pageIndex = 1, pageSize = 10, name = '', email = '', role = '', status = -1 } = payload;
        const response = await newAPI.get('/user', {
            params: {
                pageIndex,
                pageSize,
                name,
                email,
                role,
                status
            }
        });
        // Map the response to match the expected format
        const users = Array.isArray(response.data) ? response.data : response.data.data || [];
        return users;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// Fetch single user by ID
export const fetchSingleUserAPI = async (userId) => {
    try {
        const response = await newAPI.get(`/user/${userId}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// Add new user
export const addUserAPI = async (userData) => {
    try {
        const response = await newAPI.post('/user', userData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// Update existing user
export const updateUserAPI = async (userId, userData) => {
    try {
        const response = await newAPI.put(`/user/${userId}`, userData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// Delete user by ID
export const deleteUserAPI = async (userId) => {
    try {
        const response = await newAPI.delete(`/user/${userId}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};